export const demoDisclaimer = 'DEMO — NOT FOR REGULATORY USE — ไม่ใช่ข้อมูลสำหรับใช้ยื่นจริง';
